// Shared helpers for the engagement portal surfaces (popup + leaderboard widget).
// Uses the portal's own login token directly against the engagement backend
// (its auth accepts portal AUTHENTICATION tokens).
export const API = process.env.REACT_APP_ENGAGEMENT_API || 'http://localhost:5055';

export function getEngagementLoginToken() {
  try {
    return JSON.parse(localStorage.getItem('cred'))?.token || null;
  } catch (e) {
    return null;
  }
}

// Logged-in signal: a cred token is present (logOut() removes cred). We do NOT
// rely on cred.isLogin — the login flow doesn't persist it consistently. As a
// belt-and-braces guard against a stale cred lingering, we also hide on the
// auth/login pages (where you only are when signed out).
export function isPortalLoggedIn() {
  try {
    const cred = JSON.parse(localStorage.getItem('cred'));
    if (!cred || !cred.token) return false;
    const path = (typeof window !== 'undefined' && window.location && window.location.pathname) || '';
    if (/^\/(auth|login|signin|register)(\/|$)/i.test(path)) return false;
    return true;
  } catch (e) {
    return false;
  }
}

export function eeFetch(path, opts = {}) {
  const token = getEngagementLoginToken();
  return fetch(`${API}${path}`, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...(opts.headers || {}) },
  });
}

// Events the caller still has pending actions on (register / self-rate).
export async function fetchPendingActions() {
  try {
    const r = await eeFetch('/widget/open-registrations');
    if (!r.ok) return [];
    const j = await r.json();
    return j?.data?.events || [];
  } catch (e) {
    return [];
  }
}

export function fmtDeadline(v) {
  if (!v) return null;
  const d = new Date(String(v).replace(' ', 'T') + '+05:30');
  if (isNaN(d.getTime())) return null;
  return d.toLocaleString([], { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
